export default {
  email: 'email',
  password: 'password'
}
